import { render, staticRenderFns } from "./IconChips.vue?vue&type=template&id=09938ed0&"
import script from "./IconChips.vue?vue&type=script&lang=js&"
export * from "./IconChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports